import type { TaxCalculationStrategy, CountryConfig } from '../types'

export const uaeTaxStrategy: TaxCalculationStrategy = {
  calculateIncomeTax(_income: number, _config: CountryConfig): number {
    // No personal income tax in UAE
    return 0
  },

  calculateCapitalGainsTax(
    _gains: number,
    _holdingDays: number,
    _config: CountryConfig
  ): number {
    // No capital gains tax in UAE
    return 0
  },

  calculateWithdrawalTax(
    _amount: number,
    _assetId: string,
    _age: number,
    _config: CountryConfig
  ): number {
    // No withdrawal penalties in UAE
    return 0
  },

  /**
   * Calculate End of Service Benefits (EOSB) - UAE specific
   */
  calculateEOSB(
    basicMonthlySalary: number,
    yearsOfService: number,
    config: CountryConfig
  ): number {
    if (!config.benefits.hasEOSB || !config.benefits.eosbRules) {
      return 0
    }

    const rules = config.benefits.eosbRules
    const dailySalary = basicMonthlySalary / 30

    let totalEOSB = 0

    // First 5 years: 21 days per year
    const firstFiveYears = Math.min(yearsOfService, 5)
    totalEOSB += dailySalary * rules.firstFiveYearsRate * firstFiveYears

    // After 5 years: 30 days per year
    if (yearsOfService > 5) {
      const additionalYears = yearsOfService - 5
      totalEOSB += dailySalary * rules.afterFiveYearsRate * additionalYears
    }

    // Cap at 2 years of basic salary
    const maxEOSB = basicMonthlySalary * 12 * rules.maxYearsCapped

    return Math.round(Math.min(totalEOSB, maxEOSB))
  },
}
